// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AcoesMarketing_UploadFotoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for POST /marketing/acoes/upload_foto — the public URL of the stored photo. */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AcoesMarketing_UploadFotoResponseDados {
url: string
}

export type AcoesMarketing_UploadFotoResponse = ApiResponse<AcoesMarketing_UploadFotoResponseDados>;

registerResponseContract('AcoesMarketing_UploadFotoResponse', {
  url: { type: 'string',  required: true },
})
